// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'

// UI
import 'animate.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// iview
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';

// gantt甘特图
import { gantt } from 'dhtmlx-gantt';
import "dhtmlx-gantt/codebase/dhtmlxgantt.css"

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(ViewUI);
Vue.use(gantt);

// 全局地址
Vue.prototype.baseURL = process.env.API_ROOT;

Vue.directive('focus', {
    inserted(el, b) {
        el.focus();
    }
});

/* eslint-disable no-new */
const app = new Vue({
    el: '#app',
    router,
    store,
    components: {
        App
    },
    template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js